import { useState, useEffect } from 'react'
import { useLocation } from '@remix-run/react'
import { getUniqueQueryString } from '@helpers/core/getUniqueQueryString'

export function useQueryStringPreservedUrl(url: string) {
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => setIsMounted(true), [])

  // To avoid conflicts with cached URLs, we should treat the
  // query string preservation only on client side.
  const shouldPreserveQuery = isMounted

  const { search } = useLocation()

  const [urlWithoutSearch = '', existingSearch = ''] = url.split('?')

  if (search && shouldPreserveQuery) {
    return getUniqueQueryString({
      url: urlWithoutSearch,
      search: [search, existingSearch].join('&'),
    })
  }

  return url
}
